module.exports = __webpack_public_path__ + "img/sl.177912a7.jpg";